/**
 * Init our custom date field component
 */
export default {
  data: () => ({
    dateFormat: 'yyyy-MM-dd'
  }),
  methods: {
    /**
     * @vuese
     * Disable base firefox functionality
     */
    initNativeDateField(inputObj) {
      // disable firefox calendar
      inputObj.el.on('click', (e) => {
        e.preventDefault()
      })
      return inputObj
    }
  }
}
